<template>
  <Drawer :title="title" :width="width" :closable="false" v-model="visible" @on-close="handleVisible">
    <div class="c-play-header">
      <div>
        <el-button :disabled="disableAdd" @click="$emit('on-select')">添加素材对比</el-button>
      </div>
      <div class="c-play-tags">
        <Tag v-for="item in materIds" :key="item.imageId" :name="item.imageId" closable @on-close="handleClose">{{ item.imageName }}</Tag>
      </div>
    </div>
    <div class="c-echarts">
      <compare-echart :loading="loading" :compare-options="echartsOptions" />
    </div>
  </Drawer>
</template>
<script>
import { mul } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import CompareEchart from '@/components/echarts/echart.vue'

import { getVideoPlayDatas } from '@/api/report.model'
export default {
  name: 'playChart',
  components: { CompareEchart },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    materIds: {
      type: Array
    },
    width: {
      type: Number
    },
    max: {
      type: Number,
      default: 10
    },
    params: {
      type: Object
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    disableAdd() {
      return isArray(this.materIds) && this.materIds.length >= this.max
    }
  },
  data() {
    return {
      loading: null,
      playChart: [],
      echartsOptions: {}
    }
  },
  methods: {
    getData() {
      this.loading = true
      getVideoPlayDatas({
        imageIds: this.materIds.map((ret) => ret.imageId),
        beginTime: this.params.beginTime,
        endTime: this.params.endTime
      }).then((data) => {
        this.loading = false
        if (isArray(data)) this.playChart = data
        this.creatEchart()
      })
    },
    creatEchart() {
      // 图表配置
      const legends = this.materIds.map((ret) => ret.imageName)
      const series =
        this.playChart.length &&
        this.materIds.map((ret, i) => {
          const referData = [
            1,
            this.playChart[i].playDuration2sRate,
            this.playChart[i].playDuration3sRate,
            this.playChart[i].playDuration5sRate,
            this.playChart[i].playDuration10sRate,
            this.playChart[i].playOverRate
          ]
          return {
            name: ret.imageName,
            type: 'line',
            data: referData.map((_) => mul(_, 100))
          }
        })

      this.echartsOptions = {
        legend: {
          bottom: 0,
          itemGap: 20,
          itemWidth: 12,
          itemHeight: 6,
          align: 'right',
          data: legends,
          textStyle: {
            lineHeight: 4
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          padding: 10,
          formatter: (params) => {
            const tooltips = this.materIds.map((ret, i) => {
              const key =
                params[0].name === '0S'
                  ? 'totalPlay'
                  : params[0].name.indexOf('S') > -1
                    ? `playDuration${params[0].name.toLowerCase()}Num`
                    : 'playOver'
              return `<dd class="tooltop-span"><span style="background-color: ${params[i].color}"></span> 播放数：${this.playChart[i][key]} &nbsp;&nbsp; 百分比：${params[i].value}% </dd>`
            })
            let formatHtml = `<h3 class="tooltip-h3">${params[0].name}</h3>`
            formatHtml += tooltips.join('')
            return formatHtml
          }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            position: 'bottom',
            offset: 0,
            data: ['0S', '2S', '3S', '5S', '10S', '完播']
          }
        ],
        yAxis: {
          name: '百分比',
          nameGap: 5,
          max: 100,
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        },
        series,
        grid: { top: 35, left: 16, right: 16, bottom: 54, containLabel: !0 }
      }
    },
    handleVisible() {
      this.loading = false
      this.$emit('on-reset')
    },
    handleClose(e, name) {
      this.$emit('on-delete', name)
    }
  },
  watch: {
    materIds(nVal) {
      if (isArray(nVal) && nVal.length) this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-play-header {
  display: flex;
  height: 90px;

  .c-play-tags {
    padding: 0 20px;
    flex: auto;

    ::v-deep .ivu-tag-closable {
      display: inline-flex;
      border-radius: 28px;
      align-items: center;
      margin-right: 16px;
      margin-bottom: 12px;

      .ivu-tag-text {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 140px;
        display: inline-block;
      }

      .ivu-icon-ios-close {
        display: inline-block;
      }
    }
  }
}

.c-echarts {
  width: 100%;
  height: calc(100% - 90px);
  padding: 10px 16px;
}
</style>
